/* =====================================================================
   bwa-embudo.js \u2014 v1.7 \u2014 CRM \u00b7 Embudo, ficha del cliente y \u2600\ufe0f Mi d\u00eda
   v1.7 (29-oct-2026): \ud83d\udce3 Campa\u00f1a con dos canales. Correo: plantilla de correo del
   CRM al segmento filtrado, "Ver a cu\u00e1ntos llega" (hoy / en cola / se saltan),
   Programar, y la lista de campa\u00f1as en curso con Pausar / Reanudar / Cancelar
   (sale sola por d\u00edas desde el servidor). WhatsApp: el selector muestra el
   texto real de la plantilla. Necesita api/wa-admin.js v32.
   v1.6 (22-oct-2026): bot\u00f3n \ud83d\udce3 Campa\u00f1a (due\u00f1o y administradores): manda una
   plantilla de WhatsApp al segmento que est\u00e1 filtrado en el Embudo (pa\u00eds,
   etapa, marca, b\u00fasqueda). Primero muestra a cu\u00e1ntos llegar\u00eda y por qu\u00e9 se
   salta a los dem\u00e1s (sin permiso, ya recibi\u00f3 marketing esta semana, fuera de
   horario…) y pide confirmar. Necesita api/wa-admin.js v30.
   v1.5 (19-oct-2026): en la ficha, cada producto del carrito es un enlace a la
   tienda (abre en otra pesta\u00f1a) para revisar env\u00edo del vendedor, variante y stock.
   Necesita api/wa-admin.js v29.2 (manda la url de cada producto).
   v1.4: pesta\u00f1a Mi d\u00eda: chats que esperan respuesta + la lista de a qui\u00e9n
         escribir hoy, con \u2713 Hecho y \u23ed Ma\u00f1ana.
   v1.3: ficha completa del cliente (panel a la derecha) desde el Embudo
         y desde el chat, con o sin email: datos, pedidos, carrito, \u00faltimos
         mensajes, cuotas, notas del equipo y due\u00f1o.
   v1.2: due\u00f1o de cada cliente (filtro, cambio desde la fila), bot\u00f3n
         \ud83d\udc65 Equipo (pa\u00edses y reparto) y 'Solo mis clientes' para asesores.
   v1.1: el bot\u00f3n Actualizar solo aparece a quien puede recalcular (roles).
   Va en Shopify: assets/bwa-embudo.js (lo carga sections/bandeja-wa.liquid)

   Muestra a TODOS los clientes ordenados por pa\u00eds y etapa:
     Lead \u2192 Registrado \u2192 Posible comprador \u2192 Comprador nuevo \u2192
     Recurrente \u2192 En riesgo \u2192 Dormido
   con marcas (VIP, carrito, cotizaci\u00f3n, contra entrega, cuotas,
   subastador, sin WhatsApp). Los datos vienen de /api/wa-admin
   (acci\u00f3n crm-embudo); el servidor filtra y ordena, aqu\u00ed solo se pinta.

   Todo el HTML se arma con createElement: nada de HTML dentro de
   strings (evita el problema del /en/ y cualquier inyecci\u00f3n).
   ===================================================================== */
(function () {
  'use strict';

  var ETAPAS = [
    { k: 'lead', ico: '\ud83d\udce8', nombre: 'Lead', ayuda: 'Escribi\u00f3 por WhatsApp o por un anuncio y no tiene cuenta.' },
    { k: 'registrado', ico: '\ud83c\udd95', nombre: 'Registrado', ayuda: 'Tiene cuenta, sin carrito y sin compras.' },
    { k: 'posible', ico: '\ud83d\uded2', nombre: 'Posible comprador', ayuda: 'Carrito abierto o cotizaci\u00f3n sin pagar de los \u00faltimos 60 d\u00edas.' },
    { k: 'nuevo', ico: '\ud83c\udf89', nombre: 'Comprador nuevo', ayuda: '1 pedido, hace menos de 45 d\u00edas.' },
    { k: 'recurrente', ico: '\ud83d\udd01', nombre: 'Recurrente', ayuda: '2 o m\u00e1s pedidos, el \u00faltimo hace menos de 45 d\u00edas.' },
    { k: 'riesgo', ico: '\u26a0\ufe0f', nombre: 'En riesgo', ayuda: 'Compr\u00f3 antes y lleva de 45 a 90 d\u00edas sin comprar.' },
    { k: 'dormido', ico: '\ud83d\udca4', nombre: 'Dormido', ayuda: 'M\u00e1s de 90 d\u00edas sin comprar, o nunca compr\u00f3 y no da se\u00f1ales hace 60 d\u00edas.' }
  ];
  var MARCAS = [
    { k: 'vip', ico: '\ud83d\udc51', nombre: 'VIP' },
    { k: 'carrito', ico: '\ud83d\uded2', nombre: 'Carrito' },
    { k: 'cotizacion', ico: '\ud83e\uddfe', nombre: 'Cotizaci\u00f3n sin pagar' },
    { k: 'cod', ico: '\ud83d\udcb5', nombre: 'Contra entrega' },
    { k: 'cuotas', ico: '\ud83d\udcb3', nombre: 'Cuotas' },
    { k: 'subastador', ico: '\ud83d\udd28', nombre: 'Subastador' },
    { k: 'sin_wa', ico: '\ud83d\udeab', nombre: 'Sin WhatsApp' }
  ];
  var PAISES = [
    { k: '', ico: '\ud83c\udf0e', nombre: 'Todos' },
    { k: 'VE', ico: '\ud83c\uddfb\ud83c\uddea', nombre: 'Venezuela' },
    { k: 'AR', ico: '\ud83c\udde6\ud83c\uddf7', nombre: 'Argentina' },
    { k: 'CO', ico: '\ud83c\udde8\ud83c\uddf4', nombre: 'Colombia' },
    { k: 'HN', ico: '\ud83c\udded\ud83c\uddf3', nombre: 'Honduras' },
    { k: 'US', ico: '\ud83c\uddfa\ud83c\uddf8', nombre: 'EE. UU.' },
    { k: 'OT', ico: '\ud83c\udf10', nombre: 'Otros' },
    { k: 'SP', ico: '\u2754', nombre: 'Sin pa\u00eds' }
  ];
  var ETAPA_POR_K = {};
  ETAPAS.forEach(function (e) { ETAPA_POR_K[e.k] = e; });
  var MARCA_POR_K = {};
  MARCAS.forEach(function (m) { MARCA_POR_K[m.k] = m; });
  var PAIS_POR_K = {};
  PAISES.forEach(function (p) { PAIS_POR_K[p.k] = p; });

  var ctx = null;
  var est = { pais: '', etapa: '', marca: '', dueno: '', busca: '', orden: 'valor', desde: 0, datos: null, lista: [], turno: 0, sincronizando: false };
  var ui = null;

  /* ---------- utilidades ---------- */
  /* v1.5: estilo del enlace del producto (el resto del CSS vive en bandeja-wa.liquid) */
  (function () {
    if (document.getElementById('bwa-fi-css')) return;
    var st = document.createElement('style');
    st.id = 'bwa-fi-css';
    st.textContent = '.bwa-fi-prod-link{color:inherit;text-decoration:underline;text-decoration-color:#f2b48f;text-underline-offset:3px;overflow-wrap:anywhere;}' +
      '.bwa-fi-prod-link:hover{color:#b35400;text-decoration-color:#b35400;}' +
      '.bwa-fi-prod-link:focus-visible{outline:2px solid #FF6A1F;outline-offset:2px;border-radius:4px;}' +
      /* v1.7: ventana de campaña */
      '.bwa-modal-caja{font-family:var(--f-body);}' +
      '.bwa-cmp-canal .bwa-num-btn{display:flex;flex-direction:column;align-items:center;gap:3px;}' +
      '.bwa-cmp-canal .bwa-num-btn small{font:400 10.5px var(--f-mono);color:var(--lo);}' +
      '.bwa-cmp-previa{background:var(--ink);border:1px solid var(--line-soft);border-radius:9px;padding:10px 13px;margin-top:8px;}' +
      '.bwa-cmp-asunto{font:600 11px var(--f-mono);color:var(--lo);padding-bottom:6px;margin-bottom:6px;border-bottom:1px dashed var(--line);overflow-wrap:anywhere;}' +
      '.bwa-cmp-texto{font:12.5px/1.55 var(--f-body);color:var(--hi);white-space:pre-wrap;overflow-wrap:anywhere;max-height:150px;overflow-y:auto;}' +
      '.bwa-cmp-texto b{color:var(--accent);font-weight:600;}' +
      '.bwa-cmp-pie{font:10.5px var(--f-mono);color:var(--lo2);margin-top:8px;line-height:1.5;}' +
      '.bwa-cmp-resumen{margin:14px 0 6px;font:13px/1.6 var(--f-body);color:var(--hi);}' +
      '.bwa-cmp-primeros{margin-top:6px;color:var(--lo);font-size:12.5px;}' +
      '.bwa-cmp-plan{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:10px 0;}' +
      '.bwa-cmp-kpi{background:var(--ink);border:1px solid var(--line);border-radius:9px;padding:10px;text-align:center;min-width:0;}' +
      '.bwa-cmp-kpi b{display:block;font:700 20px var(--f-display);color:var(--hi);}' +
      '.bwa-cmp-kpi span{font:10.5px var(--f-mono);color:var(--lo);text-transform:uppercase;letter-spacing:.04em;}' +
      '.bwa-cmp-detalle{margin:0 0 6px 18px;padding:0;font:12.5px/1.6 var(--f-body);color:var(--lo);}' +
      '.bwa-cmp-curso{margin-top:12px;display:flex;flex-direction:column;gap:6px;}' +
      '.bwa-cmp-curso-t{font:600 11px var(--f-mono);text-transform:uppercase;letter-spacing:.04em;color:var(--lo);}' +
      '.bwa-cmp-curso-fila{display:flex;align-items:center;gap:8px;background:var(--ink);border:1px solid var(--line);border-radius:9px;padding:8px 10px;}' +
      '.bwa-cmp-curso-info{flex:1;min-width:0;display:flex;flex-direction:column;font:12.5px var(--f-body);color:var(--hi);}' +
      '.bwa-cmp-curso-info span{font:11px var(--f-mono);color:var(--lo);}' +
      '.bwa-cmp-curso-acc{display:flex;gap:4px;flex-shrink:0;}' +
      '.bwa-cmp-curso-acc .bwa-cli-btn-sec{margin-left:0;padding:5px 8px;}';
    document.head.appendChild(st);
  })();
  function h(tag, props, hijos) {
    var el = document.createElement(tag);
    if (props) {
      Object.keys(props).forEach(function (k) {
        var v = props[k];
        if (v === null || v === undefined || v === false) return;
        if (k === 'clase') el.className = v;
        else if (k === 'texto') el.textContent = v;
        else if (k.indexOf('on') === 0) el.addEventListener(k.slice(2), v);
        else el.setAttribute(k, v === true ? '' : v);
      });
    }
    (hijos || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  }
  function vaciar(el) { while (el.firstChild) el.removeChild(el.firstChild); }
  function dinero(n) {
    n = Number(n) || 0;
    return '$' + (n >= 100 ? Math.round(n).toLocaleString('en-US') : n.toFixed(n % 1 ? 2 : 0));
  }
  function haceDias(d) {
    if (d === null || d === undefined) return '';
    if (d <= 0) return 'hoy';
    if (d === 1) return 'ayer';
    if (d < 60) return 'hace ' + d + ' d\u00edas';
    return 'hace ' + Math.round(d / 30) + ' meses';
  }
  function puedeSync() { return !!(ctx && ctx.puedeSincronizar); }
  function puedeAsignar() { return !!(ctx && ctx.puedeAsignar); }
  /* el vendedor ya recibe solo su cartera: no necesita filtro de due\u00f1o */
  function soloCartera() { return !!(ctx && ctx.soloCartera); }
  function primerNombre(n) { return String(n || '').trim().split(/\s+/)[0] || ''; }
  function nombrePais(k) { return (PAIS_POR_K[k] || PAIS_POR_K.SP).nombre; }

  /* ---------- servidor ---------- */
  function api(cuerpo) {
    cuerpo.token = ctx.token();
    return fetch(ctx.api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) { return r.json(); });
  }

  function cargar(opciones) {
    opciones = opciones || {};
    var turno = ++est.turno;
    if (!opciones.agregar) est.desde = 0;
    if (ui) ui.lista.classList.add('bwa-cargando');
    return api({
      accion: 'crm-embudo', pais: est.pais, etapa: est.etapa, marca: est.marca, dueno: est.dueno,
      busca: est.busca, orden: est.orden, desde: est.desde, fresco: !!opciones.fresco
    }).then(function (d) {
      if (turno !== est.turno || !ctx.activo()) return;
      if (ctx.manejar401(d)) return;
      if (!d || !d.ok) { pintarError((d && d.error) || 'No se pudo cargar el embudo'); return; }
      if (d.vacio) { pintarVacio(); return; }
      est.datos = d;
      est.lista = opciones.agregar ? est.lista.concat(d.lista) : d.lista;
      pintar();
    }).catch(function () {
      if (turno !== est.turno || !ctx.activo()) return;
      pintarError('Sin conexi\u00f3n al cargar el embudo');
    });
  }

  function sincronizar() {
    if (est.sincronizando) return;
    est.sincronizando = true;
    if (ui && ui.botonSync) { ui.botonSync.disabled = true; ui.botonSync.textContent = '\u23f3 Actualizando\u2026'; }
    ctx.subEl.textContent = '\u23f3 Recalculando todos los clientes en el servidor (\u22481 min)\u2026';
    api({ accion: 'crm-sincronizar' }).then(function (d) {
      est.sincronizando = false;
      if (!ctx.activo()) return;
      if (ctx.manejar401(d)) return;
      if (!d || !d.ok) { alert('No se pudo actualizar: ' + ((d && d.error) || '?')); cargar(); return; }
      if (d.en_curso) ctx.subEl.textContent = 'Ya hab\u00eda una actualizaci\u00f3n corriendo. Recargando\u2026';
      setTimeout(function () { cargar({ fresco: true }); }, d.en_curso ? 20000 : 0);
    }).catch(function () {
      est.sincronizando = false;
      if (ctx.activo()) { alert('Sin conexi\u00f3n al actualizar'); cargar(); }
    });
  }

  /* ---------- esqueleto (se arma una vez; el buscador no pierde el foco) ---------- */
  function armar() {
    vaciar(ctx.msgsEl);
    var raiz = h('div', { clase: 'bwa-emb', 'data-bwa-emb': '1' });
    var top = h('div', { clase: 'bwa-emb-top', role: 'group', 'aria-label': 'Filtrar por pa\u00eds' });
    var paises = h('div', { clase: 'bwa-emb-chips' });
    var hora = h('span', { clase: 'bwa-emb-hora' });
    var botonSync = puedeSync() ? h('button', { type: 'button', clase: 'bwa-cli-btn', title: 'Recalcular ahora todos los clientes (\u22481 min)', onclick: sincronizar }, ['\ud83d\udd04 Actualizar']) : null;
    top.appendChild(paises);
    var botonEquipo = puedeAsignar() ? h('button', { type: 'button', clase: 'bwa-cli-btn bwa-cli-btn-sec', title: 'Pa\u00edses de cada persona y reparto de clientes', onclick: abrirEquipo }, ['\ud83d\udc65 Equipo']) : null;
    var botonCampana = puedeAsignar() ? h('button', { type: 'button', clase: 'bwa-cli-btn bwa-cli-btn-sec', title: 'Mandar una plantilla de WhatsApp a los clientes que est\u00e1n filtrados', onclick: abrirCampana }, ['\ud83d\udce3 Campa\u00f1a']) : null;
    top.appendChild(h('div', { clase: 'bwa-emb-der' }, [hora, botonCampana, botonEquipo, botonSync]));

    var grid = h('div', { clase: 'bwa-emb-grid', role: 'group', 'aria-label': 'Etapas del embudo' });
    var marcas = h('div', { clase: 'bwa-emb-chips bwa-emb-marcas', role: 'group', 'aria-label': 'Filtrar por marca' });

    var titulo = h('div', { clase: 'bwa-emb-titulo' });
    var busca = h('input', { type: 'search', clase: 'bwa-emb-busca', placeholder: '\ud83d\udd0e Nombre, email o tel\u00e9fono\u2026', 'aria-label': 'Buscar cliente', value: est.busca });
    busca.addEventListener('input', function () {
      clearTimeout(busca._t);
      busca._t = setTimeout(function () { est.busca = busca.value.trim(); cargar(); }, 300);
    });
    var orden = h('select', { clase: 'bwa-cli-orden', 'aria-label': 'Ordenar' }, [
      h('option', { value: 'valor', texto: '\ud83d\udcb0 Mayor valor' }),
      h('option', { value: 'reciente', texto: '\ud83d\udd52 Actividad reciente' }),
      h('option', { value: 'az', texto: '\ud83d\udd24 A \u2192 Z' })
    ]);
    orden.value = est.orden;
    orden.addEventListener('change', function () { est.orden = orden.value; cargar(); });
    /* due\u00f1o: los administradores eligen a qui\u00e9n ver; el asesor puede ver solo los suyos */
    var dueno = null;
    if (puedeAsignar()) {
      dueno = h('select', { clase: 'bwa-cli-orden', 'aria-label': 'Filtrar por due\u00f1o' });
      dueno.addEventListener('change', function () { est.dueno = dueno.value; cargar(); });
    } else if (!soloCartera()) {
      dueno = h('button', { type: 'button', clase: 'bwa-emb-chip' + (est.dueno ? ' bwa-on' : ''), 'aria-pressed': est.dueno ? 'true' : 'false', onclick: function () {
        est.dueno = est.dueno ? '' : ctx.usuario; cargar();
      } }, ['\u2b50 Solo mis clientes']);
    }
    var barra = h('div', { clase: 'bwa-emb-barra' }, [titulo, busca, dueno, orden]);

    var lista = h('div', { clase: 'bwa-emb-lista bwa-cargando', 'aria-live': 'polite' }, [
      h('div', { clase: 'bwa-emb-vacio', texto: 'Cargando el embudo\u2026' })
    ]);
    var pie = h('div', { clase: 'bwa-emb-pie' });

    [top, grid, marcas, barra, lista, pie].forEach(function (x) { raiz.appendChild(x); });
    ctx.msgsEl.appendChild(raiz);
    ui = { raiz: raiz, paises: paises, hora: hora, botonSync: botonSync, grid: grid, marcas: marcas, titulo: titulo, busca: busca, orden: orden, dueno: dueno, lista: lista, pie: pie };
  }

  /* ---------- pintado ---------- */
  function chip(texto, cuenta, activo, alClic, titulo) {
    return h('button', { type: 'button', clase: 'bwa-emb-chip' + (activo ? ' bwa-on' : ''), 'aria-pressed': activo ? 'true' : 'false', title: titulo || null, onclick: alClic },
      [texto, cuenta !== null && cuenta !== undefined ? h('b', { texto: String(cuenta) }) : null]);
  }

  function pintar() {
    var d = est.datos;
    if (!ui || !ui.raiz.isConnected) armar();

    /* pa\u00edses */
    vaciar(ui.paises);
    var totalTodos = 0;
    Object.keys(d.paises).forEach(function (k) { totalTodos += d.paises[k]; });
    PAISES.forEach(function (p) {
      var n = p.k ? (d.paises[p.k] || 0) : totalTodos;
      if (p.k && !n && est.pais !== p.k) return;
      ui.paises.appendChild(chip(p.ico + ' ' + p.nombre, n, est.pais === p.k, function () {
        est.pais = p.k; est.marca = ''; cargar();
      }));
    });

    /* hora de actualizaci\u00f3n */
    var edad = d.generado ? Math.round((Date.now() - Date.parse(d.generado)) / 60000) : null;
    var edadTxt = edad === null ? '' : (edad < 1 ? 'ahora' : edad < 60 ? 'hace ' + edad + ' min' : 'hace ' + Math.round(edad / 60) + ' h');
    ui.hora.textContent = edadTxt ? 'Actualizado ' + edadTxt : '';
    if (!est.sincronizando && ui.botonSync) { ui.botonSync.disabled = false; ui.botonSync.textContent = '\ud83d\udd04 Actualizar'; }

    /* tarjetas de etapa */
    vaciar(ui.grid);
    var totPais = 0, carritosPais = 0, compradores = 0;
    ETAPAS.forEach(function (e) {
      var x = d.etapas[e.k] || { n: 0 };
      totPais += x.n;
      carritosPais += x.carrito || 0;
      if (['nuevo', 'recurrente', 'riesgo'].indexOf(e.k) !== -1) compradores += x.n;
    });
    ui.grid.appendChild(tarjeta({ k: '', ico: '\ud83d\udc65', nombre: 'Todos', ayuda: 'Todas las etapas' }, totPais, carritosPais ? dinero(carritosPais) + ' en carritos' : '', !!carritosPais));
    ETAPAS.forEach(function (e) {
      var x = d.etapas[e.k] || { n: 0, carrito: 0, comprado: 0, anuncios: 0, con_wa: 0 };
      var linea = '', verde = false;
      if (e.k === 'lead') linea = x.anuncios ? x.anuncios + ' de anuncios' : '';
      else if (e.k === 'registrado') linea = x.con_wa ? x.con_wa + ' con WhatsApp' : '';
      else if (e.k === 'posible') { linea = x.carrito ? dinero(x.carrito) + ' en juego' : ''; verde = true; }
      else { linea = x.comprado ? dinero(x.comprado) + ' comprado' : ''; verde = e.k !== 'dormido'; }
      ui.grid.appendChild(tarjeta(e, x.n, linea, verde));
    });

    /* marcas */
    vaciar(ui.marcas);
    MARCAS.forEach(function (m) {
      var n = d.marcas[m.k] || 0;
      if (!n && est.marca !== m.k) return;
      ui.marcas.appendChild(chip(m.ico + ' ' + m.nombre, n, est.marca === m.k, function () {
        est.marca = est.marca === m.k ? '' : m.k; cargar();
      }, est.marca === m.k ? 'Quitar filtro' : 'Ver solo ' + m.nombre));
    });

    /* filtro de due\u00f1o */
    if (ui.dueno && ui.dueno.tagName === 'SELECT') {
      vaciar(ui.dueno);
      var cuenta = d.duenos || {};
      var totalD = 0;
      Object.keys(cuenta).forEach(function (k) { totalD += cuenta[k]; });
      ui.dueno.appendChild(h('option', { value: '', texto: '\ud83d\udc64 Todos los due\u00f1os (' + totalD + ')' }));
      (d.equipo || []).forEach(function (m) {
        ui.dueno.appendChild(h('option', { value: m.usuario, texto: m.nombre + ' (' + (cuenta[m.usuario] || 0) + ')' }));
      });
      ui.dueno.appendChild(h('option', { value: '__sin__', texto: 'Sin due\u00f1o (' + (cuenta.__sin__ || 0) + ')' }));
      ui.dueno.value = est.dueno;
    } else if (ui.dueno) {
      ui.dueno.className = 'bwa-emb-chip' + (est.dueno ? ' bwa-on' : '');
      ui.dueno.setAttribute('aria-pressed', est.dueno ? 'true' : 'false');
    }

    /* t\u00edtulo de la lista */
    vaciar(ui.titulo);
    var et = ETAPA_POR_K[est.etapa];
    var partes = [(et ? et.ico + ' ' + et.nombre : '\ud83d\udc65 Todas las etapas'), est.pais ? nombrePais(est.pais) : 'todos los pa\u00edses'];
    if (est.marca && MARCA_POR_K[est.marca]) partes.push(MARCA_POR_K[est.marca].nombre);
    if (est.dueno === '__sin__') partes.push('sin due\u00f1o');
    else if (est.dueno) partes.push(est.dueno === ctx.usuario ? 'mis clientes' : 'de ' + nombreDueno(est.dueno));
    ui.titulo.appendChild(document.createTextNode(partes.join(' \u00b7 ')));
    ui.titulo.appendChild(h('small', { texto: d.total + ' cliente' + (d.total === 1 ? '' : 's') + (et ? ' \u2014 ' + et.ayuda : '') }));

    /* lista */
    ui.lista.classList.remove('bwa-cargando');
    vaciar(ui.lista);
    if (!est.lista.length) {
      ui.lista.appendChild(h('div', { clase: 'bwa-emb-vacio', texto: est.busca ? 'Nadie coincide con \u00ab' + est.busca + '\u00bb en este filtro. Prueba en \ud83d\udc65 Todos.' : 'Nadie en este grupo por ahora \ud83c\udf89' }));
    }
    if (!window.__bwaProdDe) window.__bwaProdDe = {};
    est.lista.forEach(function (c) { ui.lista.appendChild(fila(c)); });

    vaciar(ui.pie);
    if (d.hay_mas) {
      ui.pie.appendChild(h('button', { type: 'button', clase: 'bwa-emb-chip', onclick: function () { est.desde = est.lista.length; cargar({ agregar: true }); } },
        ['Ver m\u00e1s (' + est.lista.length + ' de ' + d.total + ')']));
    }

    ctx.subEl.textContent = totPais + ' clientes' + (est.pais ? ' en ' + nombrePais(est.pais) : '') + ' \u00b7 ' +
      compradores + ' compradores activos \u00b7 ' + dinero(carritosPais) + ' en carritos y cotizaciones' + (edadTxt ? ' \u00b7 ' + edadTxt : '');
  }

  function tarjeta(e, n, linea, verde) {
    var activa = est.etapa === e.k;
    return h('button', {
      type: 'button', clase: 'bwa-emb-card' + (activa ? ' bwa-on' : ''), 'aria-pressed': activa ? 'true' : 'false', title: e.ayuda,
      onclick: function () { est.etapa = e.k; est.marca = ''; cargar(); }
    }, [
      h('span', { clase: 'bwa-emb-card-t', texto: e.ico + ' ' + e.nombre }),
      h('span', { clase: 'bwa-emb-card-n', texto: String(n || 0) }),
      h('span', { clase: 'bwa-emb-card-v' + (verde ? '' : ' bwa-gris'), texto: linea || '\u2014' })
    ]);
  }

  function mensajeWa(c) {
    var n = primerNombre(c.nombre);
    var hola = 'Hola' + (n ? ' ' + n : '') + ' \ud83d\udc4b te escribimos de JBOXLY. ';
    if (c.carrito_items && c.etapa !== 'dormido') {
      return 'Hola' + (n ? ' ' + n : '') + ' \ud83d\udc4b te escribimos de JBOXLY: tienes guardado ' + (c.producto ? '\u00ab' + c.producto + '\u00bb' : 'un producto') +
        (c.carrito_items > 1 ? ' y ' + (c.carrito_items - 1) + ' producto(s) m\u00e1s' : '') + ' en tu cuenta \ud83d\uded2 \u00bfTe ayudamos a completar tu pedido? Al confirmar solo pagas los productos \ud83e\udde1';
    }
    if (c.cotizaciones && !c.pedidos) return hola + 'Tu cotizaci\u00f3n sigue lista \ud83e\uddfe \u00bfTe ayudamos a completar el pago o tienes alguna duda?';
    if (c.etapa === 'nuevo') return hola + '\u00bfC\u00f3mo te fue con tu pedido? Tu opini\u00f3n nos ayuda mucho \ud83e\udde1';
    if (c.pedidos) return hola + 'Hace tiempo no te vemos por aqu\u00ed \u2014 \u00bfqu\u00e9 te traemos esta vez desde USA? \ud83e\udde1';
    if (c.tipo === 'lead') return hola + '\u00bfPudiste ver la informaci\u00f3n? Si quieres te ayudamos a crear tu cuenta y cotizar tu primera compra \ud83e\udde1';
    return hola + 'Vimos que creaste tu cuenta \u2014 \u00bfte ayudamos a cotizar tu primera compra desde USA? \ud83e\udde1';
  }

  function fila(c) {
    var tel = String(c.telefono || '').replace(/\D/g, '');
    var pais = PAIS_POR_K[c.pais] || PAIS_POR_K.SP;
    window.__bwaProdDe[tel] = c.producto || '';

    var nom = h('div', { clase: 'bwa-emb-nom' }, [h('button', { type: 'button', clase: 'bwa-fi-nombre-btn', title: 'Ver ficha completa', onclick: function () { abrirFicha({ id: c.id }); } },
      [c.nombre || c.email || (tel ? '+' + tel : '') || '(sin nombre)'])]);
    c.marcas.forEach(function (k) {
      var m = MARCA_POR_K[k];
      if (!m || k === 'carrito' || k === 'cotizacion') return; /* esas dos ya se ven en los datos */
      nom.appendChild(h('span', { clase: 'bwa-emb-marca bwa-m-' + k, title: m.nombre, texto: m.ico + ' ' + m.nombre }));
    });
    if (!est.etapa && ETAPA_POR_K[c.etapa]) nom.appendChild(h('span', { clase: 'bwa-emb-etapa', texto: ETAPA_POR_K[c.etapa].ico + ' ' + ETAPA_POR_K[c.etapa].nombre }));
    if (c.tipo === 'sin_cuenta') nom.appendChild(h('span', { clase: 'bwa-emb-etapa', title: 'Compr\u00f3 o cotiz\u00f3, pero no tiene cuenta en la web', texto: 'sin cuenta' }));

    var sub = [c.email, pais.nombre, tel ? '+' + tel : ''].filter(Boolean).join(' \u00b7 ');

    var hechos = h('div', { clase: 'bwa-emb-hechos' });
    function hecho(txt, clase) { hechos.appendChild(h('span', { clase: clase || null, texto: txt })); }
    if (c.carrito_items) hecho('\ud83d\uded2 ' + c.carrito_items + ' \u00b7 ' + dinero(c.carrito_valor) + (c.carrito_dias !== null ? ' \u00b7 ' + haceDias(c.carrito_dias) : '') + (c.producto ? ' \u2014 \u00ab' + c.producto + '\u00bb' : ''), 'bwa-verde');
    if (c.cotizaciones) hecho('\ud83e\uddfe ' + c.cotizaciones + ' cotizaci\u00f3n' + (c.cotizaciones > 1 ? 'es' : '') + ' sin pagar \u00b7 ' + dinero(c.cotizacion_valor), 'bwa-verde');
    if (c.pedidos) hecho('\ud83d\udce6 ' + c.pedidos + ' pedido' + (c.pedidos > 1 ? 's' : '') + ' \u00b7 ' + dinero(c.total_comprado) + (c.ultimo_pedido_dias !== null ? ' \u00b7 \u00faltimo ' + haceDias(c.ultimo_pedido_dias) : ''));
    if (c.chat) hecho('\ud83d\udcac ' + (c.chat_dias !== null ? 'escribi\u00f3 ' + haceDias(c.chat_dias) : 'tiene chat'));
    if (c.anuncio) hecho('\ud83d\udce2 ' + c.anuncio);
    if (!puedeAsignar() && !soloCartera()) hecho('\ud83d\udc64 ' + (c.dueno_nombre || 'sin due\u00f1o'), c.dueno === ctx.usuario ? 'bwa-mio' : null);
    if (!c.pedidos && !c.carrito_items && c.registrado_dias !== null) hecho('Registrado ' + haceDias(c.registrado_dias));

    var acciones = h('div', { clase: 'bwa-emb-acc' });
    if (puedeAsignar()) acciones.appendChild(selectorDueno(c));
    if (c.chat && tel) {
      acciones.appendChild(h('button', { type: 'button', clase: 'bwa-cli-btn', onclick: function () { ctx.abrirChat(tel); } }, ['\ud83d\udcac Chat']));
    } else if (tel.length >= 8 && (c.carrito_items || ['lead', 'registrado', 'posible'].indexOf(c.etapa) !== -1)) {
      acciones.appendChild(h('button', {
        type: 'button', clase: 'bwa-cli-btn', title: 'Enviar plantilla aprobada por WhatsApp (abre el chat en la bandeja)',
        onclick: function () { ctx.plantilla(tel, primerNombre(c.nombre), nombrePais(c.pais), c.carrito_items || 0, c.nombre || ''); }
      }, ['\ud83d\udce8 Plantilla']));
    }
    if (tel.length >= 8) {
      acciones.appendChild(h('a', {
        clase: 'bwa-cli-btn bwa-cli-btn-sec', target: '_blank', rel: 'noopener',
        title: 'Abrir en tu WhatsApp con el mensaje ya escrito', 'aria-label': 'Escribir por WhatsApp a ' + (c.nombre || tel),
        href: 'https://wa.me/' + tel + '?text=' + encodeURIComponent(mensajeWa(c))
      }, ['\ud83d\udfe2']));
    }

    return h('div', { clase: 'bwa-emb-fila' }, [
      h('div', { clase: 'bwa-emb-info' }, [nom, h('div', { clase: 'bwa-emb-sub', texto: sub }), hechos]),
      acciones
    ]);
  }

  function nombreDueno(u) {
    var m = ((est.datos && est.datos.equipo) || []).filter(function (x) { return x.usuario === u; })[0];
    return m ? m.nombre : u;
  }

  /* Cambiar el due\u00f1o desde la fila: guarda al instante y tambi\u00e9n le pasa el chat */
  function selectorDueno(c) {
    var sel = h('select', { clase: 'bwa-emb-dueno', 'aria-label': 'Due\u00f1o de ' + (c.nombre || 'este cliente'), title: 'Due\u00f1o del cliente' });
    if (!c.dueno) sel.appendChild(h('option', { value: '', texto: '\ud83d\udc64 Sin due\u00f1o' }));
    ((est.datos && est.datos.equipo) || []).forEach(function (m) {
      sel.appendChild(h('option', { value: m.usuario, texto: '\ud83d\udc64 ' + m.nombre }));
    });
    sel.value = c.dueno || '';
    sel.addEventListener('change', function () {
      var antes = c.dueno || '';
      var nuevo = sel.value;
      if (!nuevo) { sel.value = antes; return; }
      sel.disabled = true;
      api({ accion: 'crm-asignar', id: c.id, usuario: nuevo }).then(function (d) {
        sel.disabled = false;
        if (ctx.manejar401(d)) return;
        if (!d || !d.ok) { sel.value = antes; alert('No se pudo cambiar el due\u00f1o: ' + ((d && d.error) || '?')); return; }
        c.dueno = d.dueno; c.dueno_nombre = d.dueno_nombre;
        var hecho = sel.options[0] && !sel.options[0].value ? sel.options[0] : null;
        if (hecho) sel.removeChild(hecho);
        sel.classList.add('bwa-ok');
        setTimeout(function () { sel.classList.remove('bwa-ok'); }, 1500);
      }).catch(function () { sel.disabled = false; sel.value = antes; alert('Sin conexi\u00f3n'); });
    });
    return sel;
  }

  /* ---------- \ud83d\udc65 Equipo: pa\u00edses de cada persona y reparto ---------- */
  function abrirEquipo() {
    var fondo = h('div', { clase: 'bwa-modal bwa-on', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Equipo y reparto de clientes' });
    var caja = h('div', { clase: 'bwa-modal-caja bwa-eq-caja' });
    var cuerpo = h('div', { clase: 'bwa-eq-lista' }, [h('p', { clase: 'bwa-ayuda', texto: 'Cargando equipo\u2026' })]);
    var aviso = h('p', { clase: 'bwa-eq-aviso' });
    var cambios = {};
    function cerrar() { document.removeEventListener('keydown', teclas); if (fondo.parentNode) fondo.parentNode.removeChild(fondo); }
    function teclas(e) { if (e.key === 'Escape') cerrar(); }
    var botonGuardar = h('button', { type: 'button', clase: 'bwa-btn-ok', disabled: true, onclick: function () { guardar(false); } }, ['Guardar']);
    var botonRepartir = h('button', { type: 'button', clase: 'bwa-btn-no', title: 'Guarda y reparte ahora los clientes sin due\u00f1o', onclick: function () { guardar(true); } }, ['Guardar y repartir ahora']);
    caja.appendChild(h('h3', { texto: '\ud83d\udc65 Equipo y reparto de clientes' }));
    caja.appendChild(h('p', { clase: 'bwa-ayuda', texto: 'Cada cliente nuevo o sin due\u00f1o va solo a quien cubre su pa\u00eds, recibe clientes y tiene menos. Pasa cada 2 horas. Sin pa\u00edses marcados = atiende todos. Las personas y claves se crean en "Usuarios del panel".' }));
    caja.appendChild(cuerpo);
    caja.appendChild(aviso);
    caja.appendChild(h('div', { clase: 'bwa-modal-pie' }, [h('button', { type: 'button', clase: 'bwa-btn-no', onclick: cerrar }, ['Cerrar']), botonRepartir, botonGuardar]));
    fondo.appendChild(caja);
    fondo.addEventListener('click', function (e) { if (e.target === fondo) cerrar(); });
    document.addEventListener('keydown', teclas);
    document.body.appendChild(fondo);

    api({ accion: 'equipo' }).then(function (d) {
      if (ctx.manejar401(d)) { cerrar(); return; }
      vaciar(cuerpo);
      if (!d || !d.ok) { cuerpo.appendChild(h('p', { clase: 'bwa-ayuda', texto: '\u26a0\ufe0f ' + ((d && d.error) || 'No se pudo cargar') })); return; }
      if (!d.equipo.length) { cuerpo.appendChild(h('p', { clase: 'bwa-ayuda', texto: 'Todav\u00eda no hay nadie con acceso a la bandeja. Cr\u00e9alos en "Usuarios del panel" con rol Asesor.' })); return; }
      aviso.textContent = d.sin_dueno ? d.sin_dueno + ' cliente(s) sin due\u00f1o ahora mismo.' : 'Todos los clientes tienen due\u00f1o.';
      d.equipo.forEach(function (m) {
        var estado = { paises: m.paises.slice(), recibe: m.recibe };
        var chips = h('div', { clase: 'bwa-eq-paises', role: 'group', 'aria-label': 'Pa\u00edses de ' + m.nombre });
        function marcar() {
          cambios[m.usuario] = { usuario: m.usuario, paises: estado.paises.slice(), recibe: estado.recibe };
          botonGuardar.disabled = false;
          pintarChips();
        }
        function pintarChips() {
          vaciar(chips);
          chips.appendChild(h('button', { type: 'button', clase: 'bwa-eq-pais' + (!estado.paises.length ? ' bwa-on' : ''), 'aria-pressed': !estado.paises.length ? 'true' : 'false', onclick: function () { estado.paises = []; marcar(); } }, ['Todos']));
          (d.paises_posibles || []).forEach(function (k) {
            var on = estado.paises.indexOf(k) !== -1;
            chips.appendChild(h('button', { type: 'button', clase: 'bwa-eq-pais' + (on ? ' bwa-on' : ''), 'aria-pressed': on ? 'true' : 'false', onclick: function () {
              if (on) estado.paises = estado.paises.filter(function (x) { return x !== k; });
              else estado.paises.push(k);
              marcar();
            } }, [nombrePais(k)]));
          });
        }
        pintarChips();
        var idChk = 'bwa-eq-recibe-' + m.usuario;
        var chk = h('input', { type: 'checkbox', id: idChk });
        chk.checked = !!m.recibe;
        chk.addEventListener('change', function () { estado.recibe = chk.checked; marcar(); });
        cuerpo.appendChild(h('div', { clase: 'bwa-eq-fila' }, [
          h('div', { clase: 'bwa-eq-cab' }, [
            h('b', { texto: m.nombre }),
            h('span', { clase: 'bwa-eq-rol', texto: m.rol }),
            h('span', { clase: 'bwa-eq-num', texto: m.clientes + ' cliente' + (m.clientes === 1 ? '' : 's') })
          ]),
          chips,
          h('label', { clase: 'bwa-eq-recibe', 'for': idChk }, [chk, ' Recibe clientes nuevos del reparto'])
        ]));
      });
    }).catch(function () { vaciar(cuerpo); cuerpo.appendChild(h('p', { clase: 'bwa-ayuda', texto: '\u26a0\ufe0f Sin conexi\u00f3n' })); });

    function guardar(repartir) {
      var lista = Object.keys(cambios).map(function (k) { return cambios[k]; });
      botonGuardar.disabled = true; botonRepartir.disabled = true;
      aviso.textContent = '\u23f3 Guardando\u2026';
      var i = 0;
      (function siguiente() {
        if (i >= lista.length) {
          cambios = {};
          if (repartir) { cerrar(); sincronizar(); } else { aviso.textContent = '\u2705 Guardado. El reparto se aplica en la pr\u00f3xima actualizaci\u00f3n.'; botonRepartir.disabled = false; }
          return;
        }
        var c = lista[i++];
        api({ accion: 'equipo-editar', usuario: c.usuario, paises: c.paises, recibe: c.recibe }).then(function (d) {
          if (!d || !d.ok) { aviso.textContent = '\u26a0\ufe0f ' + ((d && d.error) || 'No se pudo guardar'); botonGuardar.disabled = false; botonRepartir.disabled = false; return; }
          siguiente();
        }).catch(function () { aviso.textContent = '\u26a0\ufe0f Sin conexi\u00f3n'; botonGuardar.disabled = false; botonRepartir.disabled = false; });
      })();
    }
  }


  /* =================== CAMPA\u00d1A POR SEGMENTO (v1.6) =================== */
  function filtroActual() {
    return { pais: est.pais || '', etapa: est.etapa || '', marca: est.marca || '', busca: est.busca || '', dueno: est.dueno || '' };
  }
  function describirFiltro() {
    var partes = [];
    partes.push(est.pais ? nombrePais(est.pais) : 'Todos los pa\u00edses');
    if (est.etapa) { var e = ETAPAS.filter(function (x) { return x.k === est.etapa; })[0]; partes.push(e ? e.nombre : est.etapa); } else partes.push('todas las etapas');
    if (est.marca) partes.push('marca ' + est.marca);
    if (est.busca) partes.push('"' + est.busca + '"');
    return partes.join(' \u00b7 ');
  }
  function abrirCampana() {
    var fondo = h('div', { clase: 'bwa-modal bwa-on', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Campaña' });
    var caja = h('div', { clase: 'bwa-modal-caja' });
    var filtro = filtroActual();
    var canal = 'wa';
    var ultimo = null;
    var plantillasWa = [], plantillasCorreo = [];
    var cupoCorreo = null;
    var segmento = 0;

    /* ---- piezas de la ventana ---- */
    var ayuda = h('p', { clase: 'bwa-ayuda' });
    var btnWa = h('button', { type: 'button', clase: 'bwa-num-btn bwa-num-on', 'aria-pressed': 'true', onclick: function () { elegirCanal('wa'); } },
      [h('span', { texto: '💬 WhatsApp' }), h('small', { texto: 'plantilla de Meta · solo con permiso · tope 30' })]);
    var btnCorreo = h('button', { type: 'button', clase: 'bwa-num-btn', 'aria-pressed': 'false', onclick: function () { elegirCanal('correo'); } },
      [h('span', { texto: '✉️ Correo' }), h('small', { texto: 'plantilla de correo · sale solo por días' })]);
    var canales = h('div', { clase: 'bwa-num-pick bwa-cmp-canal', role: 'group', 'aria-label': 'Canal' }, [btnWa, btnCorreo]);
    var etiquetaPl = h('label', { texto: 'Plantilla aprobada por Meta' });
    var sel = h('select', { clase: 'bwa-cli-orden', 'aria-label': 'Plantilla', style: 'width:100%;' }, [h('option', { value: '', texto: 'Cargando plantillas…' })]);
    var etiquetaVar2 = h('label', { texto: 'Segundo dato (opcional)' });
    var var2 = h('input', { type: 'text', clase: 'bwa-emb-busca', placeholder: 'Segundo dato de la plantilla (si lo pide): producto, asesor…', 'aria-label': 'Segunda variable', maxlength: '60', style: 'width:100%;box-sizing:border-box;' });
    var previa = h('div', { clase: 'bwa-cmp-previa', style: 'display:none;' });
    var resumen = h('div', { clase: 'bwa-cmp-resumen' });
    var plan = h('div', { clase: 'bwa-cmp-plan', style: 'display:none;' });
    var detalle = h('ul', { clase: 'bwa-cmp-detalle' });
    var enCurso = h('div', { clase: 'bwa-cmp-curso' });
    var aviso = h('p', { clase: 'bwa-eq-aviso' });
    var botonProbar = h('button', { type: 'button', clase: 'bwa-btn-no', onclick: probar }, ['🔍 Ver a cuántos llega']);
    var botonEnviar = h('button', { type: 'button', clase: 'bwa-btn-ok', disabled: true, onclick: enviar }, ['📣 Enviar']);

    function cerrar() { document.removeEventListener('keydown', teclas); if (fondo.parentNode) fondo.parentNode.removeChild(fondo); }
    function teclas(e) { if (e.key === 'Escape') cerrar(); }
    function plantillaElegida() {
      var lista = canal === 'correo' ? plantillasCorreo : plantillasWa;
      return lista.filter(function (p) { return p.id === sel.value; })[0] || null;
    }
    function textoAyuda() {
      var seg = 'Segmento: ' + describirFiltro() + (segmento ? ' (' + segmento + ' clientes)' : '') + '. ';
      if (canal === 'correo') return seg + 'Solo recibe quien tiene correo válido, no pidió baja y no recibió marketing en 7 días (WhatsApp y correo comparten esa cuenta). Sale ' + (cupoCorreo ? cupoCorreo.tope : 60) + ' por día, en horario de su país, y sigue solo hasta terminar.';
      return seg + 'Solo recibe quien aceptó avisos por WhatsApp, no haya recibido marketing en 7 días, no esté conversando hoy y esté en horario (9 a 20 de su país). Máximo 30 por campaña y comparte el cupo diario del robot.';
    }
    function elegirCanal(c) {
      canal = c;
      btnWa.classList.toggle('bwa-num-on', c === 'wa'); btnWa.setAttribute('aria-pressed', c === 'wa' ? 'true' : 'false');
      btnCorreo.classList.toggle('bwa-num-on', c === 'correo'); btnCorreo.setAttribute('aria-pressed', c === 'correo' ? 'true' : 'false');
      etiquetaPl.textContent = c === 'correo' ? 'Plantilla de correo' : 'Plantilla aprobada por Meta';
      etiquetaVar2.style.display = c === 'correo' ? 'none' : ''; var2.style.display = c === 'correo' ? 'none' : '';
      ayuda.textContent = textoAyuda();
      ultimo = null; botonEnviar.disabled = true; botonEnviar.textContent = '📣 Enviar';
      plan.style.display = 'none'; vaciar(detalle);
      pintarSelector();
    }
    function pintarSelector() {
      vaciar(sel);
      var lista = canal === 'correo' ? plantillasCorreo : plantillasWa;
      if (!lista.length) { sel.appendChild(h('option', { value: '', texto: canal === 'correo' ? 'No hay plantillas de correo' : 'No hay plantillas' })); pintarPrevia(); return; }
      sel.appendChild(h('option', { value: '', texto: 'Elige una plantilla…' }));
      if (canal === 'correo') {
        lista.forEach(function (p) { sel.appendChild(h('option', { value: p.id, texto: p.nombre })); });
      } else {
        var vistos = {};
        lista.forEach(function (p) {
          if (vistos[p.id]) { vistos[p.id].paises.push(p.pais); return; }
          vistos[p.id] = { p: p, paises: [p.pais] };
        });
        Object.keys(vistos).forEach(function (id) {
          var x = vistos[id];
          sel.appendChild(h('option', { value: id, texto: x.p.titulo + ' · ' + x.paises.join('+') + (x.p.vars > 1 ? ' · pide 2 datos' : '') }));
        });
      }
      resumen.textContent = segmento + ' clientes en el segmento. Elige la plantilla y pulsa "Ver a cuántos llega".';
      pintarPrevia();
    }
    /* vista previa: el correo (asunto + texto) o el cuerpo de la plantilla de WhatsApp (v1.7) */
    function pintarPrevia() {
      var p = plantillaElegida();
      vaciar(previa);
      if (!p) { previa.style.display = 'none'; return; }
      previa.style.display = '';
      var texto = '';
      if (canal === 'correo') {
        previa.appendChild(h('div', { clase: 'bwa-cmp-asunto', texto: 'Asunto: ' + (p.asunto || '') }));
        texto = ((p.titulo ? p.titulo + '\n\n' : '') + 'Hola {nombre},\n\n' + (p.cuerpo || '') + (p.boton_texto ? '\n\n[ ' + p.boton_texto + ' ]' : '')).replace(/\*\*/g, '');
      } else {
        texto = p.cuerpo ? p.cuerpo.replace(/\{\{2\}\}/g, var2.value.trim() ? var2.value.trim() : '{{2}}') : ('(Meta no devolvió el texto) Hola {{1}}, ' + String(p.titulo || '').toLowerCase() + '…');
      }
      var cuerpoEl = h('div', { clase: 'bwa-cmp-texto' });
      texto.split(/(\{\{?[a-z0-9_]+\}?\})/i).forEach(function (t) {
        if (/^\{\{?[a-z0-9_]+\}?\}$/i.test(t)) cuerpoEl.appendChild(h('b', { texto: t }));
        else if (t) cuerpoEl.appendChild(document.createTextNode(t));
      });
      previa.appendChild(cuerpoEl);
      if (canal === 'correo') previa.appendChild(h('div', { clase: 'bwa-cmp-pie', texto: 'Al pie va solo el enlace «No quiero recibir más correos» (obligatorio). {nombre} y {pais} se llenan con los datos de cada cliente.' }));
      else previa.appendChild(h('div', { clase: 'bwa-cmp-pie', texto: '{{1}} = primer nombre del cliente' + (p.vars > 1 ? ' · {{2}} = el segundo dato (o tu nombre)' : '') }));
    }
    function pintarOmitidos(om) {
      vaciar(detalle);
      Object.keys(om || {}).sort(function (a, b) { return om[b] - om[a]; }).forEach(function (k) {
        detalle.appendChild(h('li', { texto: om[k] + ' · ' + k }));
      });
    }
    function tarjetaPlan(n, t) { return h('div', { clase: 'bwa-cmp-kpi' }, [h('b', { texto: String(n) }), h('span', { texto: t })]); }
    function pintarPlan(d) {
      vaciar(plan);
      plan.style.display = '';
      plan.appendChild(tarjetaPlan(d.hoy, 'salen hoy'));
      plan.appendChild(tarjetaPlan(d.en_cola, d.en_cola ? 'en cola · ' + d.dias + (d.dias === 1 ? ' día' : ' días') : 'en cola'));
      var saltan = 0; Object.keys(d.omitidos || {}).forEach(function (k) { saltan += d.omitidos[k]; });
      plan.appendChild(tarjetaPlan(saltan, 'se saltan'));
    }
    /* campañas en curso (correo): pausar / reanudar / cancelar */
    function pintarEnCurso(lista) {
      vaciar(enCurso);
      var vivas = (lista || []).filter(function (c) { return c.estado === 'activa' || c.estado === 'pausada'; });
      if (!vivas.length) return;
      enCurso.appendChild(h('div', { clase: 'bwa-cmp-curso-t', texto: '✉️ Campañas de correo en curso' }));
      vivas.forEach(function (c) {
        var fila = h('div', { clase: 'bwa-cmp-curso-fila' });
        fila.appendChild(h('div', { clase: 'bwa-cmp-curso-info' }, [
          h('b', { texto: c.nombre || c.id }),
          h('span', { texto: c.enviados + ' enviados · ' + c.quedan + ' en cola' + (c.errores ? ' · ' + c.errores + ' con error' : '') + (c.estado === 'pausada' ? ' · en pausa' : '') })
        ]));
        var acc = h('div', { clase: 'bwa-cmp-curso-acc' });
        acc.appendChild(h('button', { type: 'button', clase: 'bwa-cli-btn bwa-cli-btn-sec', onclick: function () { cambiarEstado(c, c.estado === 'pausada' ? 'activa' : 'pausada'); } }, [c.estado === 'pausada' ? '▶ Reanudar' : '⏸ Pausar']));
        acc.appendChild(h('button', { type: 'button', clase: 'bwa-cli-btn bwa-cli-btn-sec', onclick: function () { if (confirm('¿Cancelar la campaña «' + (c.nombre || '') + '»? Los ' + c.quedan + ' que faltan no recibirán el correo.')) cambiarEstado(c, 'cancelada'); } }, ['✕ Cancelar']));
        fila.appendChild(acc);
        enCurso.appendChild(fila);
      });
    }
    function cambiarEstado(c, estado) {
      api({ accion: 'campana-estado', id: c.id, estado: estado }).then(function (d) {
        if (ctx.manejar401(d)) { cerrar(); return; }
        if (!d || !d.ok) { aviso.textContent = '⚠️ ' + ((d && d.error) || 'No se pudo'); return; }
        api({ accion: 'campanas' }).then(function (l) { if (l && l.ok) pintarEnCurso(l.campanas); });
      }).catch(function () { aviso.textContent = '⚠️ Sin conexión'; });
    }
    function probar() {
      if (!sel.value) { aviso.textContent = 'Elige la plantilla.'; return; }
      aviso.textContent = ''; botonProbar.disabled = true; botonEnviar.disabled = true;
      resumen.textContent = '⏳ Revisando el segmento…'; vaciar(detalle); plan.style.display = 'none';
      api({ accion: 'campana', canal: canal, plantilla: sel.value, var2: var2.value.trim(), filtro: filtro, prueba: true }).then(function (d) {
        botonProbar.disabled = false;
        if (ctx.manejar401(d)) { cerrar(); return; }
        if (!d || !d.ok) { resumen.textContent = '⚠️ ' + ((d && d.error) || 'No se pudo revisar'); return; }
        ultimo = d;
        vaciar(resumen);
        if (canal === 'correo') {
          resumen.appendChild(h('b', { texto: 'Llegaría a ' + d.candidatos + ' de ' + d.segmento + ' clientes' }));
          resumen.appendChild(document.createTextNode(' del segmento.'));
          if (d.candidatos && d.por_enviar.length) resumen.appendChild(h('div', { clase: 'bwa-cmp-primeros', texto: 'Primeros: ' + d.por_enviar.slice(0, 6).map(function (x) { return x.nombre || x.email; }).join(', ') + (d.candidatos > 6 ? '…' : '') }));
          pintarPlan(d);
          pintarOmitidos(d.omitidos);
          botonEnviar.disabled = !d.candidatos;
          botonEnviar.textContent = d.candidatos ? '📣 Programar ' + d.candidatos : '📣 Programar';
          return;
        }
        var n = d.por_enviar.length, quedan = d.cupo ? d.cupo.quedan : 0, tope = Math.min(n, 30, quedan);
        resumen.appendChild(h('b', { texto: 'Llegaría a ' + n + ' de ' + d.segmento + ' clientes' }));
        resumen.appendChild(document.createTextNode(' del segmento. '));
        if (n > tope) resumen.appendChild(h('span', { texto: 'Hoy salen ' + tope + ' (tope de 30 por campaña y ' + quedan + ' que quedan del cupo diario del robot); el resto no se envía solo, vuelve a lanzarla mañana.' }));
        if (n && d.por_enviar.length) resumen.appendChild(h('div', { clase: 'bwa-cmp-primeros', texto: 'Primeros: ' + d.por_enviar.slice(0, 6).map(function (x) { return x.nombre || x.telefono; }).join(', ') + (n > 6 ? '…' : '') }));
        pintarOmitidos(d.omitidos);
        botonEnviar.disabled = !tope;
        botonEnviar.textContent = tope ? '📣 Enviar a ' + tope : '📣 Enviar';
      }).catch(function () { botonProbar.disabled = false; resumen.textContent = '⚠️ Sin conexión'; });
    }
    function enviar() {
      if (!ultimo || !sel.value) return;
      var nombrePl = sel.options[sel.selectedIndex].textContent;
      if (canal === 'correo') {
        if (!confirm('¿Programar el correo «' + nombrePl + '» para ' + ultimo.candidatos + ' clientes?\n\nSegmento: ' + describirFiltro() + '\nHoy salen ' + ultimo.hoy + ' y el resto sigue solo (' + (ultimo.cupo ? ultimo.cupo.tope : 60) + ' por día). Se puede pausar o cancelar desde aquí.')) return;
      } else {
        var n = Math.min(ultimo.por_enviar.length, 30, ultimo.cupo ? ultimo.cupo.quedan : 0);
        if (!confirm('¿Enviar la plantilla "' + nombrePl + '" a ' + n + ' clientes por WhatsApp?\n\nSegmento: ' + describirFiltro() + '\nEsto no se puede deshacer.')) return;
      }
      botonEnviar.disabled = true; botonProbar.disabled = true; aviso.textContent = '⏳ Enviando… no cierres esta ventana.';
      api({ accion: 'campana', canal: canal, plantilla: sel.value, var2: var2.value.trim(), filtro: filtro }).then(function (d) {
        botonProbar.disabled = false;
        if (ctx.manejar401(d)) { cerrar(); return; }
        if (!d || !d.ok) { aviso.textContent = '⚠️ ' + ((d && d.error) || 'No se pudo enviar'); botonEnviar.disabled = false; return; }
        vaciar(resumen); plan.style.display = 'none';
        if (canal === 'correo') {
          resumen.appendChild(h('b', { texto: '✅ Campaña programada: ' + d.enviados + ' enviados ahora, ' + d.quedan + ' en cola' }));
          resumen.appendChild(h('div', { texto: 'El resto sale solo cada hora (hasta ' + (d.cupo ? d.cupo.tope : 60) + ' por día, en horario de su país). Cada correo queda en la ficha del cliente.' }));
          if (d.errores && d.errores.length) resumen.appendChild(h('div', { texto: '⚠️ ' + d.errores.length + ' con error: ' + d.errores.slice(0, 3).join(' · ') }));
          pintarOmitidos(d.omitidos_envio);
          api({ accion: 'campanas' }).then(function (l) { if (l && l.ok) pintarEnCurso(l.campanas); });
        } else {
          resumen.appendChild(h('b', { texto: '✅ Enviados: ' + d.enviados.length }));
          if (d.errores.length) resumen.appendChild(h('div', { texto: '⚠️ ' + d.errores.length + ' con error: ' + d.errores.slice(0, 3).join(' · ') }));
          resumen.appendChild(h('div', { texto: 'Cada envío queda en el chat del cliente y en su ficha. Cupo del día: ' + (d.cupo ? d.cupo.usados + '/' + d.cupo.tope : '') }));
          pintarOmitidos(d.omitidos);
        }
        aviso.textContent = '';
        ultimo = null;
      }).catch(function () { aviso.textContent = '⚠️ Sin conexión. Revisa en los chats o en las fichas qué salió antes de repetir.'; botonProbar.disabled = false; });
    }

    caja.appendChild(h('h3', { texto: '📣 Campaña' }));
    caja.appendChild(ayuda);
    caja.appendChild(h('label', { texto: 'Canal' }));
    caja.appendChild(canales);
    caja.appendChild(enCurso);
    caja.appendChild(etiquetaPl);
    caja.appendChild(sel);
    caja.appendChild(previa);
    caja.appendChild(etiquetaVar2);
    caja.appendChild(var2);
    caja.appendChild(resumen);
    caja.appendChild(plan);
    caja.appendChild(detalle);
    caja.appendChild(aviso);
    caja.appendChild(h('div', { clase: 'bwa-modal-pie' }, [h('button', { type: 'button', clase: 'bwa-btn-no', onclick: cerrar }, ['Cerrar']), botonProbar, botonEnviar]));
    fondo.appendChild(caja);
    fondo.addEventListener('click', function (e) { if (e.target === fondo) cerrar(); });
    document.addEventListener('keydown', teclas);
    document.body.appendChild(fondo);
    sel.addEventListener('change', function () { botonEnviar.disabled = true; ultimo = null; plan.style.display = 'none'; pintarPrevia(); });
    var2.addEventListener('input', pintarPrevia);
    ayuda.textContent = textoAyuda();

    /* las dos listas de plantillas se piden una vez (WhatsApp y correo) */
    api({ accion: 'campana', filtro: filtro, prueba: true }).then(function (d) {
      if (ctx.manejar401(d)) { cerrar(); return; }
      if (!d || !d.ok) { aviso.textContent = '⚠️ ' + ((d && d.error) || 'Error'); return; }
      plantillasWa = d.plantillas || [];
      segmento = d.segmento || 0;
      ayuda.textContent = textoAyuda();
      if (canal === 'wa') pintarSelector();
    }).catch(function () { aviso.textContent = '⚠️ Sin conexión'; });
    api({ accion: 'campana', canal: 'correo', filtro: filtro, prueba: true }).then(function (d) {
      if (!d || !d.ok) return;
      plantillasCorreo = d.plantillas || [];
      cupoCorreo = d.cupo || null;
      segmento = d.segmento || segmento;
      pintarEnCurso(d.campanas || []);
      if (canal === 'correo') { ayuda.textContent = textoAyuda(); pintarSelector(); }
    }).catch(function () {});
  }

  /* =================== FICHA DEL CLIENTE (v1.3) =================== */
  var ESTADOS_PEDIDO = {
    'pre-alertado': 'Pre-alertado', 'pendiente-pago-productos': 'Esperando pago', 'recibida': 'Solicitud recibida',
    'en-proceso': 'En proceso', 'comprado': 'Comprado', 'despachado': 'Despachado', 'en-camino': 'En camino',
    'en-centro': 'En centro', 'entregada': 'Entregada', 'cancelada': 'Cancelada'
  };
  var fichaAbierta = null;
  function escFicha(e) { if (e.key === 'Escape') cerrarFicha(); }
  function cerrarFicha() {
    document.removeEventListener('keydown', escFicha);
    if (fichaAbierta && fichaAbierta.parentNode) fichaAbierta.parentNode.removeChild(fichaAbierta);
    fichaAbierta = null;
  }
  function fechaCorta(iso) {
    var t = Date.parse(iso || '');
    if (!t) return '';
    try { return new Date(t).toLocaleDateString('es', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return ''; }
  }
  function seccion(titulo, hijos) {
    return h('section', { clase: 'bwa-fi-sec' }, [h('h3', { texto: titulo })].concat(hijos));
  }

  /* ref: { id } o { telefono, numero_negocio, email }.  extra.escribir(texto): pone un borrador en el chat abierto */
  function abrirFicha(ref, extra) {
    extra = extra || {};
    cerrarFicha();
    var fondo = h('div', { clase: 'bwa-fi-fondo' });
    var panel = h('aside', { clase: 'bwa-fi', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Ficha del cliente', tabindex: '-1' });
    var cuerpo = h('div', { clase: 'bwa-fi-cuerpo' }, [h('p', { clase: 'bwa-fi-vacio', texto: 'Cargando ficha\u2026' })]);
    panel.appendChild(h('button', { type: 'button', clase: 'bwa-fi-x', 'aria-label': 'Cerrar ficha', onclick: cerrarFicha }, ['\u2715']));
    panel.appendChild(cuerpo);
    fondo.appendChild(panel);
    fondo.addEventListener('click', function (e) { if (e.target === fondo) cerrarFicha(); });
    document.addEventListener('keydown', escFicha);
    document.body.appendChild(fondo);
    fichaAbierta = fondo;
    panel.focus();
    api(Object.assign({ accion: 'crm-ficha' }, ref)).then(function (d) {
      if (fichaAbierta !== fondo) return;
      if (ctx.manejar401(d)) { cerrarFicha(); return; }
      vaciar(cuerpo);
      if (!d || !d.ok) { cuerpo.appendChild(h('p', { clase: 'bwa-fi-vacio', texto: '\u26a0\ufe0f ' + ((d && d.error) || 'No se pudo cargar la ficha') })); return; }
      if (!d.encontrado) {
        cuerpo.appendChild(h('h2', { texto: 'Todav\u00eda no est\u00e1 en el CRM' }));
        cuerpo.appendChild(h('p', { clase: 'bwa-fi-vacio', texto: 'Este contacto es nuevo. Entra solo al CRM en la pr\u00f3xima actualizaci\u00f3n (cada 2 horas); un administrador puede adelantarlo con \ud83d\udd04 Actualizar en el Embudo.' }));
        return;
      }
      pintarFicha(cuerpo, d, extra);
      if (extra.alCargar) { try { extra.alCargar(d); } catch (e) {} }
    }).catch(function () {
      if (fichaAbierta !== fondo) return;
      vaciar(cuerpo);
      cuerpo.appendChild(h('p', { clase: 'bwa-fi-vacio', texto: '\u26a0\ufe0f Sin conexi\u00f3n' }));
    });
  }

  function pintarFicha(cuerpo, d, extra) {
    var c = d.cliente;
    var tel = String(c.telefono || '').replace(/\D/g, '');
    var telChat = c.chat ? c.chat.telefono : tel;
    var pais = PAIS_POR_K[c.pais] || PAIS_POR_K.SP;
    var et = ETAPA_POR_K[c.etapa];

    /* cabecera */
    var pills = h('div', { clase: 'bwa-fi-pills' });
    if (et) pills.appendChild(h('span', { clase: 'bwa-emb-etapa', title: et.ayuda, texto: et.ico + ' ' + et.nombre + (c.etapa_dias !== null ? ' \u00b7 desde ' + haceDias(c.etapa_dias) : '') }));
    c.marcas.forEach(function (k) {
      var m = MARCA_POR_K[k];
      if (m) pills.appendChild(h('span', { clase: 'bwa-emb-marca bwa-m-' + k, texto: m.ico + ' ' + m.nombre }));
    });
    if (c.tipo === 'lead') pills.appendChild(h('span', { clase: 'bwa-emb-etapa', texto: 'solo WhatsApp' }));
    if (c.tipo === 'sin_cuenta') pills.appendChild(h('span', { clase: 'bwa-emb-etapa', texto: 'sin cuenta' }));

    var datos = h('dl', { clase: 'bwa-fi-datos' });
    function dato(t, v) { if (v === null || v === undefined || v === '') return; datos.appendChild(h('div', null, [h('dt', { texto: t }), typeof v === 'string' ? h('dd', { texto: v }) : h('dd', null, [v])])); }
    dato('Tel\u00e9fono', tel ? '+' + tel : 'sin tel\u00e9fono');
    dato('Email', c.email || 'sin email');
    dato('Pa\u00eds', pais.nombre);
    dato('Casillero', c.casillero);
    dato('Registrado', c.registrado_dias !== null ? haceDias(c.registrado_dias) : '');
    dato('WhatsApp', c.wa_optin ? 'acept\u00f3 avisos' : (c.chat ? 'escribi\u00f3 al chat' : 'sin permiso'));
    dato('Lleg\u00f3 por', c.origen_anuncio ? '\ud83d\udce2 ' + c.origen_anuncio : '');
    if (d.puede_asignar && d.equipo.length) {
      est.datos = est.datos || {};
      if (!est.datos.equipo || !est.datos.equipo.length) est.datos.equipo = d.equipo;
      dato('Due\u00f1o', selectorDueno({ id: c.id, nombre: c.nombre, dueno: c.dueno, dueno_nombre: c.dueno_nombre }));
    } else {
      dato('Due\u00f1o', c.dueno_nombre || 'sin due\u00f1o');
    }
    cuerpo.appendChild(h('header', { clase: 'bwa-fi-cab' }, [h('h2', { texto: c.nombre || c.email || ('+' + tel) }), pills, datos]));

    /* n\u00fameros */
    function kpi(v, t) { return h('div', { clase: 'bwa-fi-kpi' }, [h('b', { texto: v }), h('span', { texto: t })]); }
    cuerpo.appendChild(h('div', { clase: 'bwa-fi-kpis' }, [
      kpi(String(c.pedidos), c.pedidos === 1 ? 'pedido' : 'pedidos'),
      kpi(dinero(c.total_comprado), 'comprado'),
      kpi(dinero(c.carrito_valor + c.cotizacion_valor), c.cotizacion_valor ? 'carrito + cotizaci\u00f3n' : 'en carrito'),
      kpi(c.ultimo_pedido_dias !== null ? haceDias(c.ultimo_pedido_dias) : '\u2014', '\u00faltimo pedido')
    ]));

    /* acciones */
    var acc = h('div', { clase: 'bwa-fi-acc' });
    if (c.chat) acc.appendChild(h('button', { type: 'button', clase: 'bwa-cli-btn', onclick: function () { cerrarFicha(); ctx.abrirChat(c.chat.telefono); } }, ['\ud83d\udcac Abrir chat']));
    else if (tel.length >= 8) acc.appendChild(h('button', { type: 'button', clase: 'bwa-cli-btn', onclick: function () {
      window.__bwaProdDe = window.__bwaProdDe || {};
      window.__bwaProdDe[tel] = (d.carrito[0] && d.carrito[0].titulo) || '';
      ctx.plantilla(tel, primerNombre(c.nombre), pais.nombre, d.carrito.length, c.nombre || '');
    } }, ['\ud83d\udce8 Plantilla']));
    if (telChat.length >= 8) {
      var cc = { nombre: c.nombre, etapa: c.etapa, pedidos: c.pedidos, cotizaciones: c.cotizaciones, carrito_items: d.carrito.length, producto: d.carrito[0] ? d.carrito[0].titulo.slice(0, 60) : '', tipo: c.tipo };
      acc.appendChild(h('a', { clase: 'bwa-cli-btn bwa-cli-btn-sec', target: '_blank', rel: 'noopener', title: 'Abrir en tu WhatsApp con el mensaje ya escrito',
        href: 'https://wa.me/' + telChat + '?text=' + encodeURIComponent(mensajeWa(cc)) }, ['\ud83d\udfe2 WhatsApp']));
    }
    if (extra.escribir && d.carrito.length) {
      acc.appendChild(h('button', { type: 'button', clase: 'bwa-cli-btn bwa-cli-btn-sec', title: 'Deja un borrador en el chat con sus productos', onclick: function () {
        var items = d.carrito.map(function (p) { return p.titulo.split(' ').slice(0, 6).join(' '); });
        var lista = items.length > 1 ? items.slice(0, -1).join(', ') + ' y ' + items[items.length - 1] : items[0];
        cerrarFicha();
        extra.escribir('Hola' + (primerNombre(c.nombre) ? ' ' + primerNombre(c.nombre) : '') + ', vimos que tienes en tu carrito ' + lista + ' \u2014 \u00bfte ayudamos a completar tu pedido? \ud83e\udde1');
      } }, ['\u270d\ufe0f Escribirle sobre su carrito']));
    }
    if (acc.firstChild) cuerpo.appendChild(acc);

    /* pedidos */
    var peds = d.pedidos.map(function (p) {
      var cl = p.estado === 'entregada' ? ' bwa-ok' : (p.estado === 'cancelada' ? ' bwa-mal' : '');
      var extraTxt = [fechaCorta(p.fecha), /contra[ _]?entrega/i.test(p.metodo) ? '\ud83d\udcb5 contra entrega' : '', p.tipo === 'casillero' ? '\ud83d\udce6 casillero' : '', p.tracking ? 'gu\u00eda ' + p.tracking : ''].filter(Boolean).join(' \u00b7 ');
      return h('div', { clase: 'bwa-fi-ped' }, [
        h('div', null, [h('b', { texto: p.id }), h('span', { clase: 'bwa-fi-est' + cl, texto: ESTADOS_PEDIDO[p.estado] || p.estado || '\u2014' })]),
        h('div', { clase: 'bwa-fi-monto', texto: p.monto ? dinero(p.monto) : '' }),
        h('small', { texto: extraTxt })
      ]);
    });
    cuerpo.appendChild(seccion('\ud83d\udce6 Pedidos' + (d.pedidos.length ? ' (' + d.pedidos.length + ')' : ''),
      peds.length ? peds : [h('p', { clase: 'bwa-fi-vacio', texto: c.email || tel ? 'Sin pedidos todav\u00eda.' : 'Sin datos para buscar sus pedidos.' })]));

    /* carrito */
    var prods = d.carrito.map(function (p) {
      return h('div', { clase: 'bwa-fi-prod' }, [
        p.img ? h('img', { src: p.img, alt: '', loading: 'lazy', width: '44', height: '44' }) : h('span', { clase: 'bwa-fi-sinimg', 'aria-hidden': 'true' }),
        /* v1.5: el t\u00edtulo es un enlace a la tienda (abre en otra pesta\u00f1a) para revisar
           el producto: env\u00edo del vendedor a nuestro almac\u00e9n, variante, stock */
        h('div', null, [
          /^https:\/\//.test(String(p.url || '')) ? h('a', { href: p.url, target: '_blank', rel: 'noopener noreferrer', clase: 'bwa-fi-prod-link', title: 'Abrir el producto en ' + (p.tienda || 'la tienda') }, [p.titulo, ' \u2197']) : h('span', { texto: p.titulo }),
          h('small', { texto: [p.tienda ? p.tienda.toUpperCase() : '', 'x' + p.cantidad].filter(Boolean).join(' \u00b7 ') })
        ]),
        h('b', { texto: dinero(p.precio * p.cantidad) })
      ]);
    });
    cuerpo.appendChild(seccion('\ud83d\uded2 Carrito' + (d.carrito.length ? ' \u00b7 ' + dinero(c.carrito_valor) + (c.carrito_dias !== null ? ' \u00b7 ' + haceDias(c.carrito_dias) : '') : ''),
      prods.length ? prods : [h('p', { clase: 'bwa-fi-vacio', texto: c.tipo === 'cuenta' ? 'Carrito vac\u00edo.' : 'No tiene cuenta, as\u00ed que no tiene carrito.' })]));

    /* conversaci\u00f3n */
    var msgs = d.mensajes.map(function (m) {
      return h('div', { clase: 'bwa-fi-msg' + (m.direccion === 'saliente' ? ' bwa-sal' : '') }, [
        m.texto || (m.tipo ? '[' + m.tipo + ']' : ''),
        h('small', { texto: [m.direccion === 'saliente' ? (m.autor || 'JBOXLY') : 'Cliente', fechaCorta(m.fecha)].filter(Boolean).join(' \u00b7 ') })
      ]);
    });
    cuerpo.appendChild(seccion('\ud83d\udcac \u00daltimos mensajes', msgs.length ? msgs : [h('p', { clase: 'bwa-fi-vacio', texto: c.chat ? 'Sin mensajes guardados.' : 'Todav\u00eda no ha escrito por WhatsApp.' })]));

    /* cuotas */
    if (d.cuotas.length) {
      cuerpo.appendChild(seccion('\ud83d\udcb3 Cuotas', d.cuotas.map(function (q) {
        return h('div', { clase: 'bwa-fi-ped' }, [
          h('div', null, [h('b', { texto: q.titulo }), h('span', { clase: 'bwa-fi-est' + (q.estado === 'completado' ? ' bwa-ok' : ''), texto: q.estado || '\u2014' })]),
          h('div', { clase: 'bwa-fi-monto', texto: q.pagadas + '/' + q.total_cuotas }),
          h('small', { texto: (q.inicial_pagada ? 'inicial pagada' : 'inicial pendiente') + (q.proxima ? ' \u00b7 pr\u00f3xima ' + dinero(q.proxima.monto) + ' el ' + q.proxima.vence : '') })
        ]);
      })));
    }

    /* notas del equipo */
    var listaNotas = h('div', { clase: 'bwa-fi-notas' });
    function pintarNotas(notas) {
      vaciar(listaNotas);
      if (!notas.length) { listaNotas.appendChild(h('p', { clase: 'bwa-fi-vacio', texto: 'Sin notas todav\u00eda.' })); return; }
      notas.slice().reverse().forEach(function (n) {
        listaNotas.appendChild(h('div', { clase: 'bwa-fi-nota' }, [h('small', { texto: (n.autor || '') + ' \u00b7 ' + fechaCorta(n.fecha) }), n.texto]));
      });
    }
    pintarNotas(d.notas || []);
    var idNota = 'bwa-fi-nota-' + c.id;
    var area = h('textarea', { id: idNota, placeholder: 'Ej.: prefiere que le escriban en la tarde; espera cobrar el viernes\u2026', maxlength: '1000' });
    var botonNota = h('button', { type: 'button', clase: 'bwa-cli-btn', onclick: function () {
      var texto = area.value.trim();
      if (!texto) { area.focus(); return; }
      botonNota.disabled = true;
      api({ accion: 'crm-nota', id: c.id, texto: texto }).then(function (r) {
        botonNota.disabled = false;
        if (ctx.manejar401(r)) return;
        if (!r || !r.ok) { alert('No se pudo guardar la nota: ' + ((r && r.error) || '?')); return; }
        area.value = '';
        pintarNotas(r.notas || []);
      }).catch(function () { botonNota.disabled = false; alert('Sin conexi\u00f3n'); });
    } }, ['Guardar nota']);
    cuerpo.appendChild(seccion('\ud83d\udcdd Notas del equipo', [
      listaNotas,
      h('div', { clase: 'bwa-fi-nueva' }, [h('label', { 'for': idNota, clase: 'bwa-fi-vacio', texto: 'Nueva nota (la ve todo el equipo)' }), area, h('div', null, [botonNota])])
    ]));
  }


  /* =================== \u2600\ufe0f MI D\u00cdA (v1.4) =================== */
  var TIPO_ICO = { carrito: '\ud83d\uded2', cotizacion: '\ud83e\uddfe', riesgo: '\u26a0\ufe0f', vip_dormido: '\ud83d\udc51', registrado: '\ud83c\udd95', lead: '\ud83d\udce8' };
  var md = { de: null, filtro: '', datos: null, turno: 0 };

  function abrirMiDia() {
    if (md.de === null) md.de = ctx.puedeAsignar ? '' : ctx.usuario;
    cargarMiDia();
  }

  function cargarMiDia(fresco) {
    var turno = ++md.turno;
    if (!ctx.msgsEl.querySelector('[data-bwa-md]')) {
      vaciar(ctx.msgsEl);
      ctx.msgsEl.appendChild(h('div', { clase: 'bwa-md', 'data-bwa-md': '1' }, [h('p', { clase: 'bwa-emb-vacio', texto: 'Armando tu d\u00eda\u2026' })]));
    } else {
      ctx.msgsEl.querySelector('[data-bwa-md]').classList.add('bwa-cargando');
    }
    api({ accion: 'crm-midia', usuario: md.de, fresco: !!fresco }).then(function (d) {
      if (turno !== md.turno || !ctx.activo()) return;
      if (ctx.manejar401(d)) return;
      if (!d || !d.ok) { pintarMiDiaError((d && d.error) || 'No se pudo armar Mi d\u00eda'); return; }
      md.datos = d;
      pintarMiDia();
    }).catch(function () {
      if (turno !== md.turno || !ctx.activo()) return;
      pintarMiDiaError('Sin conexi\u00f3n');
    });
  }

  function pintarMiDiaError(msg) {
    vaciar(ctx.msgsEl);
    ctx.msgsEl.appendChild(h('div', { clase: 'bwa-md', 'data-bwa-md': '1' }, [
      h('p', { clase: 'bwa-emb-vacio' }, ['\u26a0\ufe0f ' + msg + ' ', h('button', { type: 'button', clase: 'bwa-emb-chip', onclick: function () { cargarMiDia(true); } }, ['Reintentar'])])
    ]));
  }

  function chatsEsperando() {
    var todos = (ctx.chats && ctx.chats()) || [];
    return todos.filter(function (c) {
      var noLeido = c.sin_leer === true || c.sin_leer === 'true';
      var arch = c.archivado === true || c.archivado === 'true';
      if (!noLeido || arch) return false;
      if (!ctx.puedeAsignar) return String(c.asignado || '') === ctx.usuario;
      if (md.de === '__sin__') return !c.asignado;
      return !md.de || String(c.asignado || '') === md.de;
    }).slice(0, 15);
  }

  function pintarMiDia() {
    var d = md.datos;
    vaciar(ctx.msgsEl);
    var raiz = h('div', { clase: 'bwa-md', 'data-bwa-md': '1' });
    ctx.msgsEl.appendChild(raiz);
    if (d.vacio) {
      raiz.appendChild(h('p', { clase: 'bwa-emb-vacio', texto: 'Todav\u00eda no se ha generado el CRM. Se genera solo cada 2 horas.' }));
      return;
    }

    /* cabecera */
    var hoy = '';
    try { hoy = new Date().toLocaleDateString('es', { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) {}
    var der = h('div', { clase: 'bwa-emb-der' });
    if (d.puede_asignar) {
      var sel = h('select', { clase: 'bwa-cli-orden', 'aria-label': 'Ver el d\u00eda de' });
      sel.appendChild(h('option', { value: '', texto: '\ud83d\udc65 D\u00eda de todo el equipo' }));
      (d.equipo || []).forEach(function (m) { sel.appendChild(h('option', { value: m.usuario, texto: '\ud83d\udc64 D\u00eda de ' + m.nombre })); });
      sel.appendChild(h('option', { value: '__sin__', texto: 'Clientes sin due\u00f1o' }));
      sel.value = md.de || '';
      sel.addEventListener('change', function () { md.de = sel.value; md.filtro = ''; cargarMiDia(); });
      der.appendChild(sel);
    }
    der.appendChild(h('button', { type: 'button', clase: 'bwa-cli-btn bwa-cli-btn-sec', title: 'Volver a armar la lista', onclick: function () { cargarMiDia(true); } }, ['\ud83d\udd04']));
    raiz.appendChild(h('div', { clase: 'bwa-md-top' }, [
      h('div', null, [h('h2', { clase: 'bwa-md-h', texto: '\u2600\ufe0f Mi d\u00eda' }), h('p', { clase: 'bwa-md-fecha', texto: hoy })]),
      der
    ]));

    var enJuego = 0;
    d.tareas.forEach(function (t) { if (t.tipo === 'carrito' || t.tipo === 'cotizacion') enJuego += t.valor; });
    var esperan = chatsEsperando();
    ctx.subEl.textContent = (esperan.length ? esperan.length + ' chat' + (esperan.length > 1 ? 's' : '') + ' esperando \u00b7 ' : '') +
      d.total + ' cliente' + (d.total === 1 ? '' : 's') + ' para escribir hoy' + (enJuego ? ' \u00b7 ' + dinero(enJuego) + ' en carritos' : '');

    /* 1) primero lo urgente: te escribieron y nadie ha respondido */
    if (esperan.length) {
      var sec = h('section', { clase: 'bwa-md-sec bwa-md-urgente' }, [h('h3', { texto: '\ud83d\udcac Te escribieron y esperan respuesta (' + esperan.length + ')' })]);
      esperan.forEach(function (c) {
        sec.appendChild(h('button', { type: 'button', clase: 'bwa-md-chat', onclick: function () { ctx.abrirChatObj(c); } }, [
          h('b', { texto: c.nombre_contacto || c.nombre || ('+' + c.telefono) }),
          h('span', { texto: String(c.ultimo_texto || '').slice(0, 90) }),
          h('small', { texto: c.asignado_nombre && ctx.puedeAsignar ? '\u2192 ' + c.asignado_nombre : '' })
        ]));
      });
      raiz.appendChild(sec);
    }

    /* 2) filtros por tipo */
    var chips = h('div', { clase: 'bwa-emb-chips' });
    chips.appendChild(chipMd('Todo', d.total, !md.filtro, function () { md.filtro = ''; pintarMiDia(); }));
    (d.tipos || []).forEach(function (t) {
      var n = d.conteo[t.tipo] || 0;
      if (!n) return;
      chips.appendChild(chipMd(TIPO_ICO[t.tipo] + ' ' + t.titulo, n, md.filtro === t.tipo, function () { md.filtro = md.filtro === t.tipo ? '' : t.tipo; pintarMiDia(); }));
    });
    raiz.appendChild(chips);

    /* 3) la lista */
    var lista = h('div', { clase: 'bwa-md-lista' });
    var visibles = d.tareas.filter(function (t) { return !md.filtro || t.tipo === md.filtro; });
    if (!visibles.length) {
      lista.appendChild(h('div', { clase: 'bwa-emb-vacio', texto: d.total ? 'Nada de este tipo por hoy.' : '\ud83c\udf89 Todo al d\u00eda. No hay clientes pendientes para hoy.' }));
    }
    visibles.forEach(function (t) { lista.appendChild(tarjetaMd(t)); });
    raiz.appendChild(lista);
    if (d.total > d.tareas.length) raiz.appendChild(h('p', { clase: 'bwa-emb-vacio', texto: 'Mostrando los ' + d.tareas.length + ' m\u00e1s importantes de ' + d.total + '. Al marcarlos como hechos aparecen los siguientes.' }));
  }

  function chipMd(texto, n, activo, alClic) {
    return h('button', { type: 'button', clase: 'bwa-emb-chip' + (activo ? ' bwa-on' : ''), 'aria-pressed': activo ? 'true' : 'false', onclick: alClic }, [texto, h('b', { texto: String(n) })]);
  }

  function tarjetaMd(t) {
    var tel = String(t.telefono || '').replace(/\D/g, '');
    var telChat = t.chat_telefono || tel;
    var pais = PAIS_POR_K[t.pais] || PAIS_POR_K.SP;
    var et = ETAPA_POR_K[t.etapa];
    var tarjeta = h('article', { clase: 'bwa-md-tarea bwa-md-' + t.tipo });
    var valorTxt = t.valor ? (t.tipo === 'carrito' || t.tipo === 'cotizacion' ? dinero(t.valor) + ' en juego' : dinero(t.valor) + ' comprado') : '';

    var acciones = h('div', { clase: 'bwa-emb-acc' });
    if (t.chat && telChat) acciones.appendChild(h('button', { type: 'button', clase: 'bwa-cli-btn', onclick: function () { ctx.abrirChat(telChat); } }, ['\ud83d\udcac Chat']));
    else if (tel.length >= 8 && t.tipo !== 'riesgo' && t.tipo !== 'vip_dormido') acciones.appendChild(h('button', { type: 'button', clase: 'bwa-cli-btn', onclick: function () {
      window.__bwaProdDe = window.__bwaProdDe || {};
      window.__bwaProdDe[tel] = t.producto || '';
      ctx.plantilla(tel, primerNombre(t.nombre), pais.nombre, t.carrito_items || 0, t.nombre || '');
    } }, ['\ud83d\udce8 Plantilla']));
    if (telChat.length >= 8) {
      acciones.appendChild(h('a', { clase: 'bwa-cli-btn bwa-cli-btn-sec', target: '_blank', rel: 'noopener', title: 'Abrir en tu WhatsApp con el mensaje ya escrito', 'aria-label': 'WhatsApp a ' + (t.nombre || telChat),
        href: 'https://wa.me/' + telChat + '?text=' + encodeURIComponent(mensajeWa({ nombre: t.nombre, etapa: t.etapa, pedidos: t.pedidos, cotizaciones: t.cotizaciones, carrito_items: t.carrito_items, producto: t.producto, tipo: t.tipo_cliente })) }, ['\ud83d\udfe2']));
    }
    function marcar(posponer, boton) {
      boton.disabled = true;
      api({ accion: 'crm-hecho', id: t.id, tipo: t.tipo, posponer: posponer }).then(function (r) {
        if (ctx.manejar401(r)) return;
        if (!r || !r.ok) { boton.disabled = false; alert('No se pudo guardar: ' + ((r && r.error) || '?')); return; }
        tarjeta.classList.add('bwa-md-lista-hecha');
        md.datos.tareas = md.datos.tareas.filter(function (x) { return x !== t; });
        md.datos.total = Math.max(0, md.datos.total - 1);
        md.datos.conteo[t.tipo] = Math.max(0, (md.datos.conteo[t.tipo] || 1) - 1);
        setTimeout(pintarMiDia, 250);
      }).catch(function () { boton.disabled = false; alert('Sin conexi\u00f3n'); });
    }
    var hecho = h('button', { type: 'button', clase: 'bwa-cli-btn bwa-md-hecho', title: 'Ya le escrib\u00ed: sale de la lista por un tiempo' }, ['\u2713 Hecho']);
    hecho.addEventListener('click', function () { marcar(false, hecho); });
    var manana = h('button', { type: 'button', clase: 'bwa-cli-btn bwa-cli-btn-sec', title: 'Record\u00e1rmelo ma\u00f1ana' }, ['\u23ed Ma\u00f1ana']);
    manana.addEventListener('click', function () { marcar(true, manana); });
    acciones.appendChild(hecho);
    acciones.appendChild(manana);

    var cab = h('div', { clase: 'bwa-md-cab' }, [
      h('span', { clase: 'bwa-md-tipo', texto: TIPO_ICO[t.tipo] + ' ' + t.titulo }),
      valorTxt ? h('span', { clase: 'bwa-md-valor', texto: valorTxt }) : null
    ]);
    var nombre = h('button', { type: 'button', clase: 'bwa-fi-nombre-btn bwa-md-nombre', title: 'Ver ficha completa', onclick: function () { abrirFicha({ id: t.id }); } },
      [t.nombre || t.email || (tel ? '+' + tel : '(sin nombre)')]);
    var sub = [pais.nombre, tel ? '+' + tel : '', et ? et.nombre : '', (t.marcas || []).indexOf('vip') !== -1 ? 'VIP' : '', (t.marcas || []).indexOf('sin_wa') !== -1 ? 'sin permiso de WhatsApp' : ''].filter(Boolean).join(' \u00b7 ');
    tarjeta.appendChild(cab);
    tarjeta.appendChild(h('div', { clase: 'bwa-md-cuerpo' }, [
      h('div', { clase: 'bwa-emb-info' }, [nombre, h('p', { clase: 'bwa-md-detalle', texto: t.detalle }), h('div', { clase: 'bwa-emb-sub', texto: sub })]),
      acciones
    ]));
    return tarjeta;
  }

  function pintarVacio() {
    vaciar(ctx.msgsEl);
    ui = null;
    ctx.msgsEl.appendChild(h('div', { clase: 'bwa-vacio', style: 'padding:40px;' }, [
      h('span', { clase: 'bwa-vacio-icono', texto: '\ud83e\udded' }),
      h('span', { clase: 'bwa-vacio-titulo', texto: 'El embudo todav\u00eda no se ha generado' }),
      h('span', { texto: puedeSync() ? 'La primera vez tarda cerca de un minuto: cruza cuentas, pedidos, carritos y chats.' : 'Se genera solo cada 2 horas, o cuando un administrador lo actualiza.' }),
      puedeSync() ? h('button', { type: 'button', clase: 'bwa-cli-btn', style: 'margin-top:14px;', onclick: function () { armar(); sincronizar(); } }, ['\u2699\ufe0f Generar el embudo ahora']) : null
    ]));
    ctx.subEl.textContent = 'Sin generar a\u00fan';
  }

  function pintarError(msg) {
    if (!ui || !ui.raiz.isConnected) armar();
    ui.lista.classList.remove('bwa-cargando');
    vaciar(ui.lista);
    ui.lista.appendChild(h('div', { clase: 'bwa-emb-vacio' }, [
      '\u26a0\ufe0f ' + msg + ' ',
      h('button', { type: 'button', clase: 'bwa-emb-chip', onclick: function () { cargar({ fresco: true }); } }, ['Reintentar'])
    ]));
  }

  window.BWAEmbudo = {
    abrir: function (contexto) {
      ctx = contexto;
      if (!ui || !ui.raiz.isConnected) armar();
      cargar();
    },
    /* desde el chat: la bandeja entrega su contexto y el tel\u00e9fono del chat */
    ficha: function (contexto, ref, extra) {
      ctx = contexto;
      abrirFicha(ref, extra);
    },
    /* pesta\u00f1a \u2600\ufe0f Mi d\u00eda */
    midia: function (contexto) {
      ctx = contexto;
      abrirMiDia();
    }
  };
})();